import { faPenToSquare } from '@fortawesome/free-regular-svg-icons'
import type { FC } from 'react'
import React from 'react'

import ActionButton from './ActionButton'

interface Props {
  onClick: () => void
  isDisabled?: boolean
}

const EditButton: FC<Props> = ({ isDisabled, onClick }) => (
  <ActionButton
    disabled={isDisabled}
    label="Edit"
    icon={faPenToSquare}
    onClick={onClick}
  />
)

export default EditButton
